'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { OrderedSet } from 'immutable';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UISideNav from 'UIComponents/nav/UISideNav';
import { usageTracker } from '../utils/usageTracker';
import withPartials from '../utils/withPartials';
const SEO = 'seo';
const QUERIES = 'queries';
const INTERNAL_LINKS = 'internalLinks';

const getOptimizationMetrics = ({
  userHasGoogleSearchConsoleAccess,
  isInternal
}) => {
  let metrics = userHasGoogleSearchConsoleAccess ? OrderedSet([SEO, QUERIES, INTERNAL_LINKS]) : OrderedSet([SEO, INTERNAL_LINKS]);

  if (!isInternal) {
    metrics = metrics.delete(SEO);
  }

  return metrics;
};

function langKey(key) {
  return `optimizationTabs.${key}`;
}

class OptimizationSidebar extends Component {
  constructor(...args) {
    super(...args);

    this.handleOnClick = (metric, e) => {
      usageTracker.track('contentOptimizationInteraction', {
        action: metric
      });

      if (e && !e.metaKey) {
        e.preventDefault();
        this.props.onClick(`${metric}${this.props.location.search}`);
      }
    };

    this.renderLink = metric => {
      const {
        createHref,
        partial
      } = this.props;
      return /*#__PURE__*/_jsx(UILink, {
        href: createHref(metric),
        onClick: partial(this.handleOnClick, metric),
        value: metric,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey(metric),
          options: {
            count: 2
          }
        })
      }, metric);
    };
  }

  getActiveMetric() {
    const {
      pathname,
      userHasGoogleSearchConsoleAccess,
      isInternal
    } = this.props;
    const metricKeys = getOptimizationMetrics({
      isInternal,
      userHasGoogleSearchConsoleAccess
    });
    return metricKeys.find(m => pathname.includes(m));
  }

  render() {
    const {
      isInternal,
      userHasGoogleSearchConsoleAccess
    } = this.props;
    const metricKeys = getOptimizationMetrics({
      isInternal,
      userHasGoogleSearchConsoleAccess
    });
    return /*#__PURE__*/_jsx(UISideNav, {
      className: "optimization-sidebar",
      value: this.getActiveMetric(),
      children: metricKeys.map(this.renderLink)
    });
  }

}

OptimizationSidebar.propTypes = {
  createHref: PropTypes.func.isRequired,
  isInternal: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  partial: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  userHasGoogleSearchConsoleAccess: PropTypes.bool.isRequired
};
export default withPartials(withRouter(OptimizationSidebar));